import { render, staticRenderFns } from "./operations.vue?vue&type=template&id=270f8a49&scoped=true"
import script from "./operations.vue?vue&type=script&lang=ts"
export * from "./operations.vue?vue&type=script&lang=ts"
import style0 from "./operations.vue?vue&type=style&index=0&id=270f8a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f8a49",
  null
  
)

export default component.exports